import React, { useEffect, useState } from 'react';
import UserManagementTab from '../UserAccess/UserManagementTab/UserManagementTab';
import UsageAnalyticsTab from '../UserAccess/UsageAnalyticsTab/UsageAnalyticsTab';
import WorkspaceAnalyticsTab from '../UserAccess/WorkspaceAnalyticsTab/WorkspaceAnalyticsTab';
import { useSelector } from 'react-redux';
import { Switch } from 'antd';
import './UserAccess.css';
import './main.css';
import RolesPermissionsTab from './RolesPermissionsTab/RolesPermissionsTab';
import WorkspaceManagementTab from './WorkspaceManagementTab/WorkspaceManagementTab';
import ClientsWorkspaceTab from './ClientsWorkspace/ClientsWorkspaceTab';
import Workspace_RolePermission from './Workspace_RolesPermission/Workspace_RolePermission';

const UserAccess = ({ user_client_id }) => {
    const [displayMenuList, setDisplayMenuList] = useState([]);
    const [selectedItem, setSelectedItem] = useState('');

    const MenuItem = [
        {
            name: 'User Management',
            role: 'manage-all-users',
        },
        {
            name: 'Roles and permissions',
            role: 'create-account-roles',
        },
        {
            name: 'Workspace Roles and permissions',
            role: 'create-workspace-roles',
        },
        // {
        //   name : 'Workspace Management',
        //   role: ''
        // },
        {
            name: 'Workspace Analytics',
            role: 'view-usage-all-workspaces',
        },
        {
            name: 'Usage Analytics',
            role: '',
        },
        // {
        //   name : 'Clients Workspace',
        //   role: ''
        // },
    ];

    const renderSelectedComponent = () => {
        switch (selectedItem) {
            case 'User Management':
                return <UserManagementTab />;
            case 'Roles and permissions':
                return <RolesPermissionsTab />;
            case 'Workspace Roles and permissions':
                return <Workspace_RolePermission />;
            // case 'Workspace Management':
            // return <WorkspaceManagementTab />;
            case 'Workspace Analytics':
                return (
                    <WorkspaceAnalyticsTab user_client_id={user_client_id} />
                );
            case 'Usage Analytics':
                return <UsageAnalyticsTab />;
            // case 'Clients Workspace':
            //   return <ClientsWorkspaceTab />;
            default:
                return <UserManagementTab />;
        }
    };

    const userSlugData = useSelector(
        (state) => state.SettingsUserProfileData.slug
    );

    useEffect(() => {
        if (userSlugData) {
            const data = MenuItem.filter(
                (item) => item.role === '' || userSlugData?.includes(item.role)
            );
            setDisplayMenuList(data);
            setSelectedItem(data[0].name);
        }
    }, [userSlugData]);

    return (
        <div className='user-access-container'>
            <div className='main-user-access-container'>
                <div className='user-access-main'>
                    <div>
                        <h3>User Access</h3>
                        <h5>
                            Create new users, customize user permissions, and
                            remove users from your account.
                        </h5>
                    </div>
                </div>
                {/* .profile-tab-bottom {
    border: 1px solid rgb(217, 217, 217);
    margin-top: -36px;
    width: 100%;
    margin-left: 35%;
} */}
                {/* <div className="user-access-logs-container">
          <div className="user-access-logs-main_2">
            <div className="user-access-logs-tabel">
              <div className="user-access-logs-text">
                Enhance account security by enabling Multi-Factor Authentication
                for all users.
                {userSlugData?.includes('enable-account-mfa') && <Switch
                  className="user-access-logs-ml-10"
                  checkedChildren={"Yes"}
                  unCheckedChildren={"No"}
                  defaultChecked
                />}
              </div>
            </div>
          </div>
        </div> */}

                <div className='routing-user-access'>
                    {displayMenuList?.map((item, index) => (
                        <div
                            key={`${item.name}-${index}`}
                            className={
                                item.name === selectedItem
                                    ? 'user-access-route-item'
                                    : 'setting-item'
                            }
                            onClick={() => {
                                setSelectedItem(item.name);
                                //gtm
                                window.dataLayer.push({
                                    event: item?.name,
                                    buttonName: item?.name,
                                    userId: JSON.parse(
                                        localStorage.getItem('userDetails')
                                    )?.id,
                                    clientId: JSON.parse(
                                        localStorage.getItem('userDetails')
                                    )?.client_id,
                                });
                            }}>
                            {item.name}
                        </div>
                    ))}
                </div>
                <div className='user-access-content'>
                    {renderSelectedComponent()}
                </div>
            </div>
        </div>
    );
};

export default UserAccess;
